import { defineMessages } from 'react-intl'

export const appMessages = defineMessages({
  activity: {
    id: 'activity',
    defaultMessage: 'Activity',
    description: 'The user’s past workouts.'
  },
  agenda: {
    id: 'agenda',
    defaultMessage: 'Agenda',
    description: 'The title of the Agenda view.'
  },
  enable: {
    id: 'enable',
    defaultMessage: 'Enable',
    description: 'The title of the Agenda view.'
  },
  add: {
    id: 'add',
    defaultMessage: 'Add',
    description: 'Used to add an element.'
  },
  and: {
    id: 'and',
    defaultMessage: 'and'
  },
  andSpaces: {
    id: 'andSpaces',
    defaultMessage: ' and '
  },
  about: {
    id: 'about',
    defaultMessage: 'About'
  },
  addValue: {
    id: 'addValue',
    defaultMessage: 'Add {value}'
  },
  aboutMe: {
    id: 'aboutMe',
    defaultMessage: 'About me'
  },
  andValues: {
    id: 'andValues',
    defaultMessage: '{value1} and {value2}'
  },
  all: {
    id: 'all',
    defaultMessage: 'All',
    description: 'Used to add an element.'
  },
  avg: {
    id: 'avg',
    defaultMessage: 'Avg',
    description: 'Used to add an element.'
  },
  any: {
    id: 'any',
    defaultMessage: 'Any',
    description: 'Used to add an element.'
  },
  feedback: {
    id: 'feedback',
    defaultMessage: 'Feedback',
    description: 'Used to add an element.'
  },
  total: {
    id: 'total',
    defaultMessage: 'Total',
    description: 'Used to add an element.'
  },
  addItem: {
    id: 'addItem',
    defaultMessage: 'Add {value}',
    description: 'Used to delete an item.'
  },
  addNote: {
    id: 'addNote',
    defaultMessage: 'Add Note',
    description: 'The notes to be added to an element.'
  },
  editNote: {
    id: 'editNote',
    defaultMessage: 'Edit Note',
    description: 'The notes to be added to an element.'
  },
  appTitle: {
    id: 'appTitle',
    defaultMessage: 'Gymaholic Training',
    description: 'The app title.'
  },
  article: {
    id: 'article',
    defaultMessage: 'Article'
  },
  blank: {
    id: 'blank',
    defaultMessage: 'Blank'
  },
  day: {
    id: 'day',
    defaultMessage: 'day'
  },
  dayCount: {
    id: 'dayCount',
    defaultMessage: '{count} {count, plural, one {day} other {days}}'
  },
  threeValuesAndOthers: {
    id: 'threeValuesAndOthers',
    defaultMessage: '{value1}, {value2}, {value3} and others.'
  },
  twoValuesAndOthers: {
    id: 'twoValuesAndOthers',
    defaultMessage: '{value1}, {value2} and others.'
  },
  oneValueAndOthers: {
    id: 'oneValueAndOthers',
    defaultMessage: '{value1} and others.'
  },
  valueAndMorePlus: {
    id: 'valueAndMorePlus',
    defaultMessage: '{value} +'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
    description: 'Button used to cancel in different contexts.'
  },
  continue: {
    id: 'continue',
    defaultMessage: 'Continue',
    description: 'Button used to continue.'
  },
  congrats: {
    id: 'congrats',
    defaultMessage: 'Congrats!',
    description: 'Button used to continue.'
  },
  letsGo: {
    id: 'letsGo',
    defaultMessage: 'Let’s go!'
  },
  training: {
    id: 'training',
    defaultMessage: 'Training'
  },
  quote: {
    id: 'quote',
    defaultMessage: 'Quote',
    description: 'Button used to continue.'
  },
  nutrition: {
    id: 'nutrition',
    defaultMessage: 'Nutrition',
    description: 'Button used to continue.'
  },
  created: {
    id: 'created',
    defaultMessage: 'Created',
    description: 'The button used to show the user’s created workouts.'
  },
  history: {
    id: 'history',
    defaultMessage: 'History',
    description: 'The button used to show the user’s training plans.'
  },
  calories: {
    id: 'calories',
    defaultMessage: 'Calories',
    description: 'The calories.'
  },
  avgCalories: {
    id: 'avgCalories',
    defaultMessage: 'Avg Calories'
  },
  avgTrainingVolume: {
    id: 'avgTrainingVolume',
    defaultMessage: 'Avg Volume'
  },
  avgDuration: {
    id: 'avgDuration',
    defaultMessage: 'Avg Duration'
  },
  estCalories: {
    id: 'estCalories',
    defaultMessage: 'Est. Calories',
    description: 'The calories.'
  },
  fitness: {
    id: 'fitness',
    defaultMessage: 'Fitness',
    description: 'The calories.'
  },
  trainingVolume: {
    id: 'trainingVolume',
    defaultMessage: 'Volume',
    description: 'The calories.'
  },
  caloriesCount: {
    id: 'caloriesCount',
    defaultMessage: '{value} kcal',
    description: 'The calories.'
  },
  clear: {
    id: 'clear',
    defaultMessage: 'Clear',
    description: 'The button used to clear all the filters (muscles, equipment, types).'
  },
  close: {
    id: 'close',
    defaultMessage: 'Close',
    description: 'The button used to close an item.'
  },
  create: {
    id: 'create',
    defaultMessage: 'Create',
    description: 'The button used to create an element.'
  },
  creating: {
    id: 'creating',
    defaultMessage: 'Creating',
    description: 'The button used to create an element.'
  },
  confirm: {
    id: 'confirm',
    defaultMessage: 'Confirm',
    description: 'The button used to confirm an action.'
  },
  clipboardValueCopied: {
    id: 'clipboardValueCopied',
    defaultMessage: '{value} copied to your clipboard',
    description: 'Input used to search exercises.'
  },
  delete: {
    id: 'delete',
    defaultMessage: 'Delete',
    description: 'Used to delete an element.'
  },
  date: {
    id: 'date',
    defaultMessage: 'Date',
    description: 'Used to delete an element.'
  },
  deleteConfirmText: {
    id: 'deleteConfirmText',
    defaultMessage: 'Are you sure you want to delete this {value}?',
    description: 'The text used in the confirm the deletion of an element.'
  },
  done: {
    id: 'done',
    defaultMessage: 'Done',
    description: 'Used to finish an action.'
  },
  doneEditing: {
    id: 'doneEditing',
    defaultMessage: 'Done Editing',
    description: 'Used to finish a reordering of items.'
  },
  duration: {
    id: 'duration',
    defaultMessage: 'Duration',
    description: 'The duration.'
  },
  deleteItem: {
    id: 'deleteItem',
    defaultMessage: 'Delete {item}',
    description: 'Used to delete an item.'
  },
  deleteItemBr: {
    id: 'deleteItemBr',
    defaultMessage: 'Delete{br}{item}',
    description: 'Used to delete an item.'
  },
  difficulty: {
    id: 'difficulty',
    defaultMessage: 'Difficulty',
    description: 'The difficulty of an element.'
  },
  downloadExerciseVideosForOffline: {
    id: 'downloadExerciseVideosForOffline',
    defaultMessage: 'Download Offline',
    description: 'Title used to download assets.'
  },
  download: {
    id: 'download',
    defaultMessage: 'Download',
    description: 'Used to download assets.'
  },
  sets: {
    id: 'sets',
    defaultMessage: 'Sets',
    description: 'Used to download assets.'
  },
  downloaded: {
    id: 'downloaded',
    defaultMessage: 'Downloaded',
    description: 'Used to download assets.'
  },
  discard: {
    id: 'discard',
    defaultMessage: 'Discard',
    description: 'Button used to discard in different contexts.'
  },
  duplicate: {
    id: 'duplicate',
    defaultMessage: 'Duplicate',
    description: 'Used to duplicate an element.'
  },
  copy: {
    id: 'copy',
    defaultMessage: 'Copy',
    description: 'Used to copy an element.'
  },
  challenge: {
    id: 'challenge',
    defaultMessage: '{count, plural, one {Challenge} other {Challenges}}',
    description: 'Used to copy an element.'
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
    description: 'The email’s input placeholder.'
  },
  empty: {
    id: 'empty',
    defaultMessage: 'The {name} can’t be empty.',
    description: 'Used to validate an empty value.'
  },
  equipment: {
    id: 'equipment',
    defaultMessage: 'Equipment',
    description: 'The list of equipment needed to perform the exercise.'
  },
  equipmentList: {
    id: 'equipmentList',
    defaultMessage: 'Equipment List',
    description: 'The list of equipment needed to perform the exercise.'
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit',
    description: 'The button used to edit an element.'
  },
  editValue: {
    id: 'editValue',
    defaultMessage: 'Edit {value}',
    description: 'The button used to edit an element.'
  },
  end: {
    id: 'end',
    defaultMessage: 'End',
    description: 'The button used to end an event.'
  },
  error: {
    id: 'error',
    defaultMessage: 'An error occurred.',
    description: 'The exercise.'
  },
  exercise: {
    id: 'exercise',
    defaultMessage: '{count, plural, one {Exercise} other {Exercises}}',
    description: 'The exercise.'
  },
  faq: {
    id: 'faq',
    defaultMessage: 'Frequently Asked Questions',
    description: 'Frequently Asked Questions.'
  },
  forYou: {
    id: 'forYou',
    defaultMessage: 'For you',
    description: 'Recommended items for the user.'
  },
  filter: {
    id: 'filter',
    defaultMessage: 'Filter',
    description: 'Recommended items for the user.'
  },
  goal: {
    id: 'goal',
    defaultMessage: '{count, plural, one {Goal} other {Goals}}',
    description: 'The goal sub title shown in the settings training info view.'
  },
  getLean: {
    id: 'getLean',
    defaultMessage: 'Get Lean',
    description: 'Used to acknowledge an action.'
  },
  gotIt: {
    id: 'gotIt',
    defaultMessage: 'Got it',
    description: 'Used to acknowledge an action.'
  },
  gym: {
    id: 'gym',
    defaultMessage: 'Gym',
    description: 'Used to acknowledge an action.'
  },
  gymAccess: {
    id: 'gymAccess',
    defaultMessage: 'Gym Equipment',
    description: 'Used to acknowledge an action.'
  },
  height: {
    id: 'height',
    defaultMessage: 'Height',
    description: 'The height sub title shown in the settings training info view.'
  },
  invalid: {
    id: 'invalid',
    defaultMessage: 'The {name} is invalid.',
    description: 'Used to validate an invalid value.'
  },
  instructions: {
    id: 'instructions',
    defaultMessage: 'Instructions',
    description: 'The elements‘ instructions.'
  },
  items: {
    id: 'items',
    defaultMessage: 'Items',
    description: 'The elements‘ instructions.'
  },
  level: {
    id: 'level',
    defaultMessage: 'Level',
    description: 'The exercise’s difficulty level.'
  },
  letsStart: {
    id: 'letsStart',
    defaultMessage: 'Let’s start',
    description: 'Congratulations message.'
  },
  list: {
    id: 'list',
    defaultMessage: 'List',
    description: 'Congratulations message.'
  },
  listIndex: {
    id: 'listIndex',
    defaultMessage: 'List {index}',
    description: 'Congratulations message.'
  },
  myEquipment: {
    id: 'myEquipment',
    defaultMessage: 'My Equipment',
    description: 'Congratulations message.'
  },
  gymEquipment: {
    id: 'gymEquipment',
    defaultMessage: '💪 Gym',
    description: 'Congratulations message.'
  },
  homeEquipment: {
    id: 'homeEquipment',
    defaultMessage: '🏡 Home',
    description: 'Congratulations message.'
  },
  long: {
    id: 'long',
    defaultMessage: 'The {name} is too long, use {max} characters maximum.',
    description: 'Used to validate a value that is too long.'
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading...',
    description: 'Used to show a loader.'
  },
  logged: {
    id: 'logged',
    defaultMessage: 'Logged',
    description: 'Used to show a loader.'
  },
  nextUp: {
    id: 'nextUp',
    defaultMessage: 'Next Up',
    description: 'The message displayed when there are no workouts available.'
  },
  plan: {
    id: 'plan',
    defaultMessage: '{count, plural, one {Plan} other {Plans}}',
    description: 'The training plan.'
  },
  pushNotificationsPermissions: {
    id: 'pushNotificationsPermissions',
    defaultMessage: 'Push notifications require permissions.'
  },
  reminder: {
    id: 'reminder',
    defaultMessage: 'Reminder',
    description: 'The training plan.'
  },
  saving: {
    id: 'saving',
    defaultMessage: 'Saving',
    description: 'Used to show a loader.'
  },
  skip: {
    id: 'skip',
    defaultMessage: 'Skip'
  },
  loggedAt: {
    id: 'loggedAt',
    defaultMessage: 'Logged',
    description: 'Text to display when an item was logged.'
  },
  log: {
    id: 'log',
    defaultMessage: 'Log',
    description: 'Text to display when an item was logged.'
  },
  markAsCompleted: {
    id: 'markAsCompleted',
    defaultMessage: 'Mark As Completed',
    description: 'Text to display when an item was logged.'
  },
  notFound: {
    id: 'notFound',
    defaultMessage: '{value} not found',
    description: 'Text to display when an item was logged.'
  },
  nothingPlanned: {
    id: 'nothingPlanned',
    defaultMessage: 'Nothing planned',
    description: 'Text to display when an item was logged.'
  },
  platform: {
    id: 'platform',
    defaultMessage: 'Platform',
    description: 'A feed post.'
  },
  paying: {
    id: 'paying',
    defaultMessage: 'Paying',
    description: 'A feed post.'
  },
  pay: {
    id: 'pay',
    defaultMessage: 'Pay',
    description: 'A feed post.'
  },
  post: {
    id: 'post',
    defaultMessage: 'Post',
    description: 'A feed post.'
  },
  percentage: {
    id: 'percentage',
    defaultMessage: '{value} %',
    description: 'The number of set in an exercise.'
  },
  seeAll: {
    id: 'seeAll',
    defaultMessage: 'See All',
    description: 'View all items.'
  },
  valueLabel: {
    id: 'valueLabel',
    defaultMessage: '{value} {label}',
    description: 'The number of set in an exercise.'
  },
  valueLabelParenthesis: {
    id: 'valueLabelParenthesis',
    defaultMessage: '{value} ({label})',
    description: 'The number of set in an exercise.'
  },
  twoValues: {
    id: 'twoValues',
    defaultMessage: '{value1} / {value2}',
    description: 'The number of set in an exercise.'
  },
  valueTimes: {
    id: 'valueTimes',
    defaultMessage: '{value} x',
    description: 'The number of set in an exercise.'
  },
  plannedAt: {
    id: 'plannedAt',
    defaultMessage: 'Planned for',
    description: 'Text to display when an item was logged.'
  },
  editReminder: {
    id: 'editReminder',
    defaultMessage: 'Edit Reminder',
    description: 'Text to display when an item was logged.'
  },
  editLoggedDate: {
    id: 'editLoggedDate',
    defaultMessage: 'Edit Logged Date',
    description: 'Text to display when an item was logged.'
  },
  play: {
    id: 'play',
    defaultMessage: 'Play',
    description: 'Text to display when an item was logged.'
  },
  publish: {
    id: 'publish',
    defaultMessage: 'Publish',
    description: 'Text to display when an item is published.'
  },
  recommend: {
    id: 'recommend',
    defaultMessage: 'Recommend',
    description: 'The action to make an item recommended (admin and trainers only).'
  },
  recommended: {
    id: 'recommended',
    defaultMessage: 'Recommended',
    description: 'The action to make an item recommended (admin and trainers only).'
  },
  share: {
    id: 'share',
    defaultMessage: 'Share',
    description: 'The action to make an item recommended (admin and trainers only).'
  },
  shareTo: {
    id: 'shareTo',
    defaultMessage: 'Share To',
    description: 'The action to make an item recommended (admin and trainers only).'
  },
  sharing: {
    id: 'sharing',
    defaultMessage: 'Sharing...',
    description: 'The action to make an item recommended (admin and trainers only).'
  },
  copyLink: {
    id: 'copyLink',
    defaultMessage: 'Copy Link',
    description: 'The action to make an item recommended (admin and trainers only).'
  },
  unrecommend: {
    id: 'unrecommend',
    defaultMessage: 'Unrecommend',
    description: 'The action to make an item recommended (admin and trainers only).'
  },
  maximum: {
    id: 'maximum',
    defaultMessage: '{key} not supported. {max} is the maximum.',
    description: 'Used when the value for the given key is too high.'
  },
  message: {
    id: 'message',
    defaultMessage: 'Message',
    description: 'Used to send a message.'
  },
  minimum: {
    id: 'minimum',
    defaultMessage: '{key} not supported. {min} is the minimum.',
    description: 'Used when the value for the given key is too low.'
  },
  menu: {
    id: 'menu',
    defaultMessage: 'Menu',
    description: 'The menu title.'
  },
  muscle: {
    id: 'muscle',
    defaultMessage: '{count, plural, one {Muscle} other {Muscles}}',
    description: 'The list of muscle the exercise target.'
  },
  new: {
    id: 'new',
    defaultMessage: 'New',
    description: 'The workout name placeholder.'
  },
  newValue: {
    id: 'newValue',
    defaultMessage: 'New {value}'
  },
  newWorkoutNamePlaceholder: {
    id: 'newWorkoutNamePlaceholder',
    defaultMessage: 'New Workout',
    description: 'The workout name placeholder.'
  },
  newPlanNamePlaceholder: {
    id: 'newPlanNamePlaceholder',
    defaultMessage: 'New Plan',
    description: 'The plan name placeholder.'
  },
  note: {
    id: 'note',
    defaultMessage: 'Note',
    description: 'The notes title.'
  },
  name: {
    id: 'name',
    defaultMessage: 'Name',
    description: 'The notes title.'
  },
  details: {
    id: 'details',
    defaultMessage: 'Details',
    description: 'The notes title.'
  },
  no: {
    id: 'no',
    defaultMessage: 'No',
    description: 'Used to decline a request.'
  },
  noEquipment: {
    id: 'noEquipment',
    defaultMessage: 'No Equipment',
    description: 'No equipment items.'
  },
  notOnline: {
    id: 'notOnline',
    defaultMessage: 'No Internet Connection',
    description: 'Displayed when there is no internet connection.'
  },
  notConnected: {
    id: 'notConnected',
    defaultMessage: 'The server is temporary unavailable, try again later.',
    description: 'Displayed when the user is not responding.'
  },
  connected: {
    id: 'connected',
    defaultMessage: 'You are now connected.',
    description: 'Displayed when the user is responsding.'
  },
  others: {
    id: 'others',
    defaultMessage: 'Others',
    description: 'The other items.'
  },
  premium: {
    id: 'premium',
    defaultMessage: 'Premium',
    description: 'The text used for the premium features.'
  },
  profile: {
    id: 'profile',
    defaultMessage: '{count, plural, one {Profile} other {Profiles}}',
    description: 'The profile text.'
  },
  privacyPolicy: {
    id: 'privacyPolicy',
    defaultMessage: 'Privacy Policy',
    description: 'The text displayed for the privacy policy.'
  },
  habit: {
    id: 'habit',
    defaultMessage: '{count, plural, one {Habit} other {Habits}}'
  },
  rep: {
    id: 'rep',
    defaultMessage: '{count, plural, one {rep} other {reps}}',
    description: 'The number of rep in an exercise.'
  },
  repCount: {
    id: 'repCount',
    defaultMessage: '{count} {count, plural, one {rep} other {reps}}',
    description: 'The number of rep in an exercise.'
  },
  rest: {
    id: 'rest',
    defaultMessage: 'Rest',
    description: 'The rest.'
  },
  reply: {
    id: 'reply',
    defaultMessage: 'Reply',
    description: 'Used to reply to an item.'
  },
  reorder: {
    id: 'reorder',
    defaultMessage: 'Reorder {value}',
    description: 'Used to reorder items.'
  },
  replace: {
    id: 'replace',
    defaultMessage: 'Replace',
    description: 'The button used to replace the current exercise.'
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
    description: 'Used to save an element.'
  },
  start: {
    id: 'start',
    defaultMessage: 'Start',
    description: 'Used to start an element.'
  },
  services: {
    id: 'services',
    defaultMessage: 'Services'
  },
  ourServices: {
    id: 'ourServices',
    defaultMessage: 'Our services'
  },
  section: {
    id: 'section',
    defaultMessage: '{count, plural, one {Section} other {Sections}}',
    description: 'A workout section.'
  },
  more: {
    id: 'more',
    defaultMessage: 'more',
    description: 'The read more button.'
  },
  less: {
    id: 'less',
    defaultMessage: 'less',
    description: 'The read less button.'
  },
  readMore: {
    id: 'readMore',
    defaultMessage: 'Read more',
    description: 'The read more button.'
  },
  settings: {
    id: 'settings',
    defaultMessage: 'Settings',
    description: 'The button used to change any setting.'
  },
  short: {
    id: 'short',
    defaultMessage: 'The {name} is too short, use at least {min} characters.',
    description: 'Used to validate a value that is too short.'
  },
  status: {
    id: 'status',
    defaultMessage: 'Status: {value}',
    description: 'The status of an element.'
  },
  stats: {
    id: 'stats',
    defaultMessage: 'Stats',
    description: 'The status of an element.'
  },
  started: {
    id: 'started',
    defaultMessage: 'Started',
    description: 'When an element has started.'
  },
  today: {
    id: 'today',
    defaultMessage: 'Today',
    description: 'The time used in different contexts.'
  },
  time: {
    id: 'time',
    defaultMessage: 'Time',
    description: 'The time used in different contexts.'
  },
  termsOfService: {
    id: 'termsOfService',
    defaultMessage: 'Terms Of Service',
    description: 'The text displayed for the terms of service.'
  },
  trainingApp: {
    id: 'trainingApp',
    defaultMessage: 'Workouts & Training Plans',
    description: 'The text displayed on all the intro screens'
  },
  brandLine: {
    id: 'brandLine',
    defaultMessage: 'We empower you to move, feel and live better.',
    description: 'The text displayed on all the intro screens'
  },
  continueWithEmail: {
    id: 'continueWithEmail',
    defaultMessage: 'Continue with Email',
    description: 'Used to log in with a email address'
  },
  type: {
    id: 'type',
    defaultMessage: '{count, plural, one {Type} other {Types}}',
    description: 'The type of an element.'
  },
  completed: {
    id: 'completed',
    defaultMessage: 'Completed',
    description: 'The type of an element.'
  },
  update: {
    id: 'update',
    defaultMessage: 'Update',
    description: 'The button used to start a workout.'
  },
  view: {
    id: 'view',
    defaultMessage: 'View',
    description: 'The button used to start a workout.'
  },
  verifyEmail: {
    id: 'verifyEmail',
    defaultMessage: 'Verify Email',
    description: 'The button used to verify the user’s email.'
  },
  goodJob: {
    id: 'goodJob',
    defaultMessage: 'Good Job',
    description: 'Congratulations message.'
  },
  grant: {
    id: 'grant',
    defaultMessage: 'Grant'
  },
  weight: {
    id: 'weight',
    defaultMessage: 'Weight',
    description: 'The weight lifted.'
  },
  weightUnit: {
    id: 'weightUnit',
    defaultMessage: 'Weight Unit',
    description: 'The weight lifted.'
  },
  weightWithUnit: {
    id: 'weightWithUnit',
    defaultMessage: '{weight} {weightUnit}',
    description: 'The Set view title.'
  },
  weekCount: {
    id: 'weekCount',
    defaultMessage: '{count} {count, plural, one {Week} other {Weeks}}',
    description: 'The weeks.'
  },
  week: {
    id: 'week',
    defaultMessage: '{count, plural, one {Week} other {Weeks}}',
    description: 'The weeks.'
  },
  workoutsCompleted: {
    id: 'workoutsCompleted',
    defaultMessage: 'Workouts Completed',
    description: 'The text used to show the workouts completed.'
  },
  workout: {
    id: 'workout',
    defaultMessage: '{count, plural, one {Workout} other {Workouts}}',
    description: 'The message displayed a user logged a workout.'
  },
  yes: {
    id: 'yes',
    defaultMessage: 'Yes',
    description: 'The word to affirm.'
  },
  user: {
    id: 'user',
    defaultMessage: 'User',
    description: 'The word to affirm.'
  },
  quit: {
    id: 'quit',
    defaultMessage: 'Quit',
    description: 'The button used to quit a vew.'
  },
  quickFilters: {
    id: 'quickFilters',
    defaultMessage: 'Quick Filters',
    description: 'The section used to quickly filter items..'
  },
  month: {
    id: 'month',
    defaultMessage: 'Month',
    description: 'The button used to show the month workout logs.'
  },
  whatsNew: {
    id: 'whatsNew',
    defaultMessage: 'What’s New',
    description: 'The button used to show the month workout logs.'
  },
  year: {
    id: 'year',
    defaultMessage: 'Year',
    description: 'The button used to show the year workout logs.'
  },
  versionValue: {
    id: 'versionValue',
    defaultMessage: 'Version: {value}',
    description: 'The app version.'
  },
  version: {
    id: 'version',
    defaultMessage: 'Version',
    description: 'The app version.'
  },
  video: {
    id: 'video',
    defaultMessage: 'Video',
    description: 'The button used to show the video workout logs.'
  },
  wouldYouLikeToFeedback: {
    id: 'wouldYouLikeToFeedback',
    defaultMessage: 'Let us know how was your training experience'
  },
  weAreHereToHelp: {
    id: 'weAreHereToHelp',
    defaultMessage: 'We’re here to help'
  },
  thankYouForYourFeedback: {
    id: 'thankYouForYourFeedback',
    defaultMessage: 'Thank you for your feedback, what did you like the most?'
  },
  tellUsHowWeCanImprove: {
    id: 'tellUsHowWeCanImprove',
    defaultMessage: 'Tell us how we can improve'
  },
  amazingExerciseSelection: {
    id: 'amazingExerciseSelection',
    defaultMessage: 'Amazing exercise selection'
  },
  amazingWorkoutSelection: {
    id: 'amazingWorkoutSelection',
    defaultMessage: 'Amazing exercise selection'
  },
  tonsOfVariations: {
    id: 'tonsOfVariations',
    defaultMessage: 'Tons of variations'
  },
  greatIntensity: {
    id: 'greatIntensity',
    defaultMessage: 'Great intensity'
  },
  madeMeFeelBetter: {
    id: 'madeMeFeelBetter',
    defaultMessage: 'Made me feel better'
  },
  hardButGreat: {
    id: 'hardButGreat',
    defaultMessage: 'Hard, but great!'
  },
  glitchyApp: {
    id: 'glitchyApp',
    defaultMessage: 'Glitchy app'
  },
  workoutCompleted: {
    id: 'workoutCompleted',
    defaultMessage: 'Workout Completed'
  },
  smoothExerciseSequence: {
    id: 'smoothExerciseSequence',
    defaultMessage: 'Smooth exercise sequence'
  },
  smoothWorkoutSequence: {
    id: 'smoothWorkoutSequence',
    defaultMessage: 'Smooth workout sequence'
  },
  tooEasy: {
    id: 'tooEasy',
    defaultMessage: 'Too easy'
  },
  poorExerciseSelection: {
    id: 'poorExerciseSelection',
    defaultMessage: 'Poor exercise selection'
  },
  tooHard: {
    id: 'tooHard',
    defaultMessage: 'Too hard'
  },
  poorWorkoutSequence: {
    id: 'poorWorkoutSequence',
    defaultMessage: 'Poor workout sequence'
  }
})
